var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useContext, useEffect, useRef, useState } from '@max/max';
import View from '@hfe/max-view';
import './index.scss';
import DoubleCard from './component/doubleCard';
import SingleCard from './component/singleCard';
import MoreBtn from './component/moreBtn';
import { MORE_MC, skData } from './utils/constant';
import { getCommonInfo } from './utils/helper';
import HorizontalCard from './component/horizontalCard';
import ThreeColumnsCard from './component/threeColumnsCard';
import ScrollView from '@hfe/max-scrollview';
import LoadingView from '@max/leez-loading-view';
import Text from '@hfe/max-text';
import { loadSupplyData } from '@nibfe/mkt-supply-api';
import Sensor from '@max/mbc-sensor';
import { getCityIdByName } from './utils/cityUtils';
import { SkeletonS } from './component/Skeleton';
const isWeb = true;
const isMRN = false;
const MyComponent = (props) => {
    var _a, _b, _c, _d;
    const { menuId, displayIds, isQueryTag, jumpType = 1, collapsable, isShowChoiceness, customTagConfig, dealText, _LXReport, dealStyle, _raptorReport, 
    // useCitySelect,
    cityFilterConfig, selectedCity, sortType, renderSkeleton, closeSkeleton, useAnchorView, relativeCity, silentLoad } = props;
    const { showMoreButtonVisible, size, moreSize, showMoreImage, moreImageStyle } = collapsable;
    const { mvReport, mcReportWithTag } = _LXReport;
    const cityIdSelect = useRef(undefined);
    const hasMoreData = useRef(true);
    const [allDeals, setAllDeals] = useState([]); // 所有加载的商品数据
    const [displayCount, setDisplayCount] = useState(size || 4); // 当前显示的商品数量
    const [totalCount, setTotalCount] = useState(0); // 服务端总数量
    const [loading, setLoading] = useState(false);
    const [showPoiIds, setShowPoiIds] = useState([]);
    const isLoadMore = useRef(false);
    const pageNo = useRef(1);
    const useNewPageNo = useRef(false);
    const pinnerLists = useRef([]);
    const hasPinnerList = useRef(false);
    const ctx = useContext(global._EngineGlobalContext);
    const channelId = useRef(((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b.channelId) || '');
    const { reportLog } = _raptorReport || {};
    const isNeedLoadingSteleton = useRef(1); // 0:不加载骨架 1：加载骨架
    const urlTargetCityId = (_d = (_c = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _c === void 0 ? void 0 : _c.queryParams) === null || _d === void 0 ? void 0 : _d.targetCityId;
    // 点击查看更多
    function handleMore() {
        isLoadMore.current = true;
        if (loading)
            return;
        mcReportWithTag && mcReportWithTag(MORE_MC, {
            valLab: {
                instance_id: menuId
            }
        });
        // 优先显示本地剩余数据
        if (displayCount < allDeals.length) {
            setDisplayCount(allDeals.length);
            setLoading(false);
            return;
        }
        // 请求新数据
        if (displayCount < totalCount) {
            // const nextPage = Math.ceil(allDeals.length / (moreSize || 20)) + 1;
            //置顶的数据之后第一次再次请求pageNo为1
            if (useNewPageNo.current) {
                pageNo.current = 0;
            }
            pageNo.current = pageNo.current + 1;
            fetchData(pageNo.current, moreSize || 20);
            useNewPageNo.current = false;
            return;
        }
        // 已显示全部数据
        setLoading(false);
    }
    // 获取数据
    function fetchData(pageNo, pageSize, experienceInfo) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            if (!isLoadMore.current) {
                setLoading(true);
            }
            const commonParam = yield getCommonInfo();
            // 根据城市筛选配置决定cityId参数
            let finalCityId;
            // 城市支持联动时，通过cityIdSelect.current获取城市。
            if (relativeCity !== 'none') {
                finalCityId = (_a = cityIdSelect === null || cityIdSelect === void 0 ? void 0 : cityIdSelect.current) !== null && _a !== void 0 ? _a : commonParam === null || commonParam === void 0 ? void 0 : commonParam.cityId;
            }
            else {
                // 不使用城市筛选组件联动
                switch (cityFilterConfig) {
                    case 'userLocation':
                        // 使用用户定位，如果cityIdSelect.current有效说明是url写入的，优先url。
                        finalCityId = (_b = cityIdSelect.current) !== null && _b !== void 0 ? _b : commonParam === null || commonParam === void 0 ? void 0 : commonParam.cityId;
                        break;
                    case 'nationwide':
                        // 展示全国供给，使用cityId为0
                        finalCityId = 0;
                        break;
                    case 'customCity':
                        // 根据城市筛选，使用配置的城市
                        if (selectedCity) {
                            const cityId = yield getCityIdByName(selectedCity.trim());
                            finalCityId = cityId || (commonParam === null || commonParam === void 0 ? void 0 : commonParam.cityId);
                        }
                        else {
                            finalCityId = commonParam === null || commonParam === void 0 ? void 0 : commonParam.cityId;
                        }
                        break;
                    default:
                        finalCityId = commonParam === null || commonParam === void 0 ? void 0 : commonParam.cityId;
                }
            }
            let result;
            try {
                const pinnedProductIds = ((_c = pinnerLists.current) === null || _c === void 0 ? void 0 : _c.length) > 0 ? pinnerLists.current.map((item) => item === null || item === void 0 ? void 0 : item.dealId) : [];
                result = yield loadSupplyData({
                    supplyGroupId: menuId,
                    moduleSource: 1,
                    commonParam: Object.assign(Object.assign({}, commonParam), { cityId: finalCityId }),
                    pageNo: pageNo,
                    pageSize: pageSize,
                    flowSource: 2,
                    bizType: 1,
                    showPoiIds,
                    extraParams: Object.assign(Object.assign({ jumpType, openLbs: sortType === 'lbs' }, experienceInfo), { needSubscript: isQueryTag === 2, 
                        // 是否需要查询角标信息
                        boothId: displayIds || '', pinnedProductIds })
                }, {
                    apiEnv: 'prod'
                    // apiEnv: 'mock',
                    // mockUrl: 'https://apitrip.meituan.com/landing/page/ticket/new/customer/zone/queryTicketDeals?isGreyTestTrip=true'
                });
                if (!(result === null || result === void 0 ? void 0 : result.data)) {
                    reportLog === null || reportLog === void 0 ? void 0 : reportLog('maker deal双列组件接口异常', result);
                    setLoading(false);
                    closeSkeleton === null || closeSkeleton === void 0 ? void 0 : closeSkeleton();
                    return;
                }
                const { dealInfoList = [], totalDealCount = 0 } = result === null || result === void 0 ? void 0 : result.data;
                let hasPoiId = dealInfoList.every(item => item.hasOwnProperty('poiId'));
                // 存在deal异常过滤、total > 实际deal数量的情况；还是展示加载更多、请求下一页时根据dealInfoList为空确认没有更多数据了。
                hasMoreData.current = !!dealInfoList.length;
                if (pageNo === 1) {
                    // 首次加载
                    let newAllDeal = dealInfoList;
                    if (hasPinnerList.current) {
                        newAllDeal = [...pinnerLists.current, ...dealInfoList];
                        hasPinnerList.current = false;
                    }
                    if (experienceInfo === null || experienceInfo === void 0 ? void 0 : experienceInfo.destinationSwitch) {
                        pinnerLists.current = dealInfoList;
                        hasPinnerList.current = true;
                        if (dealInfoList.length < 6) {
                            fetchData(1, moreSize || 20);
                            return;
                        }
                        else {
                            useNewPageNo.current = true;
                        }
                    }
                    setAllDeals(newAllDeal);
                    const realTotalCount = (totalDealCount || 0) + pinnerLists.current.length;
                    setTotalCount(realTotalCount);
                    setDisplayCount(Math.min(size || 4, newAllDeal.length));
                    //和自动锚点容器联动，适用于页面在组件请求完成之后需要自动锚定到当前组件
                    if (useAnchorView) {
                        (_d = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _d === void 0 ? void 0 : _d.emit('anchorToCurrentModule', {
                            moduleId: ctx === null || ctx === void 0 ? void 0 : ctx._moduleId
                        });
                    }
                    if (hasPoiId) {
                        setShowPoiIds(newAllDeal.map((item) => item.poiId));
                    }
                }
                else {
                    // 加载更多
                    const newAllDeals = [...allDeals, ...dealInfoList];
                    setAllDeals(newAllDeals);
                    setDisplayCount(newAllDeals.length);
                    if (hasPoiId) {
                        setShowPoiIds(prev => [...prev, ...dealInfoList.map((item) => item.poiId)]);
                    }
                }
                setLoading(false);
                if (relativeCity === 'useAroundRecommendGuide') {
                    isNeedLoadingSteleton.current = 0;
                    isLoadMore.current = true;
                }
            }
            catch (err) {
                console.log('门票Deal组件::请求异常', err);
                (_f = (_e = ctx._uiInteractionAPI) === null || _e === void 0 ? void 0 : _e.toast) === null || _f === void 0 ? void 0 : _f.show({
                    content: (err === null || err === void 0 ? void 0 : err.message) || '活动太火爆啦～'
                });
                setLoading(false);
            }
            closeSkeleton === null || closeSkeleton === void 0 ? void 0 : closeSkeleton();
        });
    }
    // 重置数据
    function resetData() {
        setAllDeals([]);
        setDisplayCount(size || 4);
        setTotalCount(0);
        setLoading(false);
        setShowPoiIds([]);
        pinnerLists.current = [];
        hasPinnerList.current = false;
        isLoadMore.current = false;
    }
    useEffect(() => {
        var _a, _b;
        console.log('门票Deal组件::初始化', {
            urlTargetCityId
        });
        if (urlTargetCityId && !cityIdSelect.current) {
            cityIdSelect.current = Number(urlTargetCityId);
        }
        renderSkeleton === null || renderSkeleton === void 0 ? void 0 : renderSkeleton();
        resetData();
        // 攻略联动时、强依赖事件，不自动发起请求。
        if (relativeCity !== 'useAroundRecommendGuide') {
            fetchData(1, moreSize || 20);
        }
        if (relativeCity === 'useCitySelect') {
            const handleCityChanged = (city) => {
                if (city === null || city === void 0 ? void 0 : city.value) {
                    console.log('门票Deal组件::城市变化', {
                        cityId: city.value
                    });
                    cityIdSelect.current = Number(city.value);
                    pageNo.current = 1;
                    renderSkeleton === null || renderSkeleton === void 0 ? void 0 : renderSkeleton();
                    resetData();
                    fetchData(pageNo.current, moreSize || 20);
                }
            };
            (_a = ctx._communication) === null || _a === void 0 ? void 0 : _a.on('cityChanged', handleCityChanged);
            return () => {
                var _a;
                (_a = ctx._communication) === null || _a === void 0 ? void 0 : _a.off('cityChanged', handleCityChanged);
            };
        }
        if (relativeCity === 'useAroundRecommendGuide') {
            const handleGuideChange = (experienceInfo) => {
                if (isNeedLoadingSteleton.current === 1) {
                    isLoadMore.current = false;
                }
                else {
                    isLoadMore.current = true;
                }
                const { playUnifyIdString, productInfoList, cityId } = experienceInfo;
                console.log('门票Deal组件::攻略联动变化', {
                    cityId,
                    playUnifyIdString
                });
                cityIdSelect.current = Number(cityId);
                pageNo.current = 1;
                fetchData(pageNo.current, moreSize || 20, {
                    experienceId: playUnifyIdString,
                    destinationSwitch: true,
                    destinationList: productInfoList
                });
            };
            (_b = ctx._communication) === null || _b === void 0 ? void 0 : _b.on('travelAroundGuideChange', handleGuideChange);
            return () => {
                var _a;
                (_a = ctx._communication) === null || _a === void 0 ? void 0 : _a.off('travelAroundGuideChange', handleGuideChange);
            };
        }
    }, [relativeCity, cityFilterConfig, selectedCity]);
    // 当前要显示的商品列表
    const displayDeals = allDeals.slice(0, displayCount);
    // 是否显示更多按钮/内容：当前显示数量小于总数量，且有商品数据
    const showMoreBtn = hasMoreData.current && displayDeals.length > 0 && displayCount < totalCount;
    const calcMarginRight = (index) => {
        if (true) {
            if ((index + 1) % 3 === 0) {
                return '0rpx';
            }
            return '12rpx';
        }
    };
    return <View>

      {dealStyle === 'three' && <View className="deal-three">
          {!!(displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.length) && !loading && <View className="deal-three-card">
              {displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.map((item, index) => {
        return <View style={{
            width: '226rpx',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: calcMarginRight(index)
        }}>
                    <ThreeColumnsCard isQueryTag={isQueryTag} isShowChoiceness={isShowChoiceness} customTagConfig={customTagConfig} dealText={dealText} _LXReport={_LXReport} index={index} menuId={menuId} item={item} key={index} channelId={channelId.current}/>
                  </View>;
    })}
            </View>}

          {showMoreBtn && !loading && <View onClick={() => showMoreButtonVisible && handleMore()}>
              <Sensor isInNativeView onAppear={() => {
        !showMoreButtonVisible && handleMore();
    }}>
                <MoreBtn showMoreImage={showMoreImage} mvReport={mvReport} menuId={menuId} moreImageStyle={moreImageStyle}/>
              </Sensor>
            </View>}
          {loading && !silentLoad && <SkeletonS type='three' count={collapsable.size}/>}
        </View>}

      {dealStyle === 'double' && <View className="deal-double">
          {!!(displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.length) && !loading && <View className="deal-double-card">
              {displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.map((item, index) => {
        return <DoubleCard dealText={dealText} _LXReport={_LXReport} index={index} menuId={menuId} item={item} key={index} channelId={channelId.current}/>;
    })}
            </View>}

          {showMoreBtn && !loading && <View onClick={() => showMoreButtonVisible && handleMore()}>
              <Sensor isInNativeView onAppear={() => {
        !showMoreButtonVisible && handleMore();
    }}>
                <MoreBtn showMoreImage={showMoreImage} mvReport={mvReport} menuId={menuId} moreImageStyle={moreImageStyle}/>
              </Sensor>
            </View>}


          {loading && !silentLoad && <SkeletonS skeletonData={skData} type="double"/>}
        </View>}


      {dealStyle === 'single' && <View className="deal-single">
          {!!(displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.length) && <View className="deal-single-card">
              {displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.map((item, index) => {
        return <SingleCard dealText={dealText} _LXReport={_LXReport} index={index} menuId={menuId} item={item} key={index} channelId={channelId.current}/>;
    })}
            </View>}

          {showMoreBtn && <View onClick={() => showMoreButtonVisible && handleMore()}>
              <Sensor isInNativeView onAppear={() => {
        !showMoreButtonVisible && handleMore();
    }}>
                <MoreBtn showMoreImage={showMoreImage} mvReport={mvReport} menuId={menuId} moreImageStyle={moreImageStyle}/>
              </Sensor>
            </View>}
          {loading && !silentLoad && <SkeletonS skeletonData={skData} type='double'/>}
        </View>}

      {dealStyle === 'horizontal' && <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} onEndReachedThreshold={200} onEndReached={() => {
        handleMore();
    }} className="deal-horizontal">
          {!!(displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.length) && (displayDeals === null || displayDeals === void 0 ? void 0 : displayDeals.map((item, index) => {
        return <HorizontalCard dealText={dealText} _LXReport={_LXReport} index={index} menuId={menuId} item={item} key={index} channelId={channelId.current}/>;
    }))}
          <LoadingView x-if={loading} level={'medium'} content={'正在加载更多'}/>
          <View x-if={displayDeals.length && !showMoreBtn} style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '18rpx'
    }}>
            <Text style={{
        color: '#999',
        display: 'flex'
    }}>{'没有更多了～'}</Text>
          </View>
        </ScrollView>}

    </View>;
};
// export default withSkeleton(memo(MyComponent), 750, 1200, skData, false);
export default memo(MyComponent);
